import { FieldType, PrintPublicationInfoField, RowType } from '../../../../components/GenericSection';
var IN_PRINT_PUBINFO_SECTION_FIELDS = [{
  field: PrintPublicationInfoField.TITLE,
  labelText: 'Source title',
  recommended: true,
  type: FieldType.TEXT
}, {
  rowtype: RowType.SM_TWO_ROW,
  fields: [{
    field: PrintPublicationInfoField.VOLUME,
    labelText: 'Vol',
    recommended: false,
    type: FieldType.TEXT,
    flex: '2'
  }, {
    field: PrintPublicationInfoField.EDITION,
    labelText: 'Edition',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: PrintPublicationInfoField.SERIES,
    labelText: 'Series',
    recommended: false,
    type: FieldType.TEXT,
    flex: '2'
  }]
}, {
  fields: [{
    field: PrintPublicationInfoField.PUBLISHER,
    labelText: 'Publisher',
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: PrintPublicationInfoField.CITY,
    labelText: 'City',
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: PrintPublicationInfoField.STATE,
    labelText: 'State',
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: PrintPublicationInfoField.YEAR,
    labelText: 'Year',
    recommended: true,
    type: FieldType.TEXT
  }]
}, {
  fields: [{
    field: PrintPublicationInfoField.START_PAGE,
    labelText: 'Page Start',
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: PrintPublicationInfoField.END_PAGE,
    labelText: 'Page End',
    recommended: true,
    type: FieldType.TEXT
  }]
}, {
  field: PrintPublicationInfoField.NON_CONSECUTIVE,
  labelText: 'Pages are nonconsecutive',
  type: FieldType.CHECKBOX
}];
export default IN_PRINT_PUBINFO_SECTION_FIELDS;